import "core-js/modules/es6.regexp.search";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axios from 'axios';
import { get, post, put, deletes, patch } from '@/api/fetch.js';
import url from '@/api/serviceAPI.config.js';
export default {
  name: 'village',
  data: function data() {
    return {
      input: '',
      tableHeight: document.body.clientHeight - 375,
      pageNum: 0,
      pageSize: 10,
      listLoading: false,
      //loading
      renterList: [],
      filters: {
        searchWord: '',
        companyId: ''
      },
      dialogAddVisible: false,
      dialogManagerAddVisible: false,
      formLabelWidth: '110px',
      addForm: {
        userName: '',
        tel: '',
        status: '',
        companyName: '',
        adminUser: ''
      },
      addLoading: false,
      total: null,
      roleList: [],
      companyList: [],
      sels: [],
      currentPage: 0,
      firstPartData: [{
        name: '租户数',
        number: 120,
        unit: '个'
      }, {
        name: '用户数',
        number: 120,
        unit: '个'
      }, {
        name: '正常数',
        number: 120,
        unit: '个'
      }, {
        name: '禁用数',
        number: 120,
        unit: '个'
      }]
    };
  },
  created: function created() {},
  activated: function activated() {},
  deactivated: function deactivated() {},
  mounted: function mounted() {
    this.getRenter();
    this.getSituationData();
  },
  methods: {
    //改变分页信息
    handleCurrentChange: function handleCurrentChange(val) {
      console.log(val);
      this.pageNum = val;
      this.getUser();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.getUser();
    },
    //获取列表
    getUser: function getUser() {
      var _this = this;
      var para = Object.assign({
        pageNum: this.pageNum ? this.pageNum - 1 : this.pageNum,
        pageSize: this.pageSize
      }, {
        searchWord: this.filters.searchWord
      });
      this.listLoading = true;
      get(url.userManager.searchCompanyUser + '/' + this.filters.companyId, para).then(function (res) {
        _this.total = res.data.totalNum;
        _this.roleList = res.data.datas;
        _this.listLoading = false;
      }).catch(function (error) {
        console.log(error);
      });
    },
    //显示添加村组弹框
    addRoleDialogShow: function addRoleDialogShow() {
      this.dialogAddVisible = true;
    },
    addManagerDialogShow: function addManagerDialogShow() {
      this.dialogManagerAddVisible = true;
    },
    //隐藏添加村组弹框
    addRoleDialogHide: function addRoleDialogHide() {
      this.dialogAddVisible = false;
      this.addForm = {
        task: {
          taskName: '',
          taskType: '',
          describes: '',
          startTime: '',
          endTime: ''
        },
        perArr: [],
        per: []
      };
    },
    //搜索
    seachRole: function seachRole() {
      this.pageNum = 0;
      this.pageSize = 10;
      this.currentPage = 0;
      this.getUser();
      this.handleCurrentChange(0);
    },
    //删除
    deleteRole: function deleteRole(row) {
      this.sels.push(row);
      this.batchRemove();
    },
    // 显示编辑界面
    editRole: function editRole(row) {
      this.dialogAddVisible = true;
      //this.addForm = Object.assign({}, row);  //有现获取列表信息
      this.getRoleDeatil(row.id, row.tenantId);
    },
    //回填详情
    getRoleDeatil: function getRoleDeatil(companyUserId, tenantId) {
      var _this2 = this;
      get(url.userManager.viewUserDetail, {
        companyUserId: companyUserId,
        tenantId: tenantId
      }).then(function (res) {
        var data = res.data;
        var userName = data.userName,
          tel = data.tel,
          status = data.status,
          companyName = data.companyName,
          adminUser = data.adminUser,
          pus = data.pus;
        adminUser = adminUser == '管理员' ? 1 : 2;
        status = status == '正常' ? 1 : 2;
        _this2.addForm = {
          userName: userName,
          tel: tel,
          status: status,
          companyName: companyName,
          adminUser: adminUser
        };
        console.log(_this2.addForm);
        _this2.companyList = pus;
        _this2.dialogAddVisible = true;
      });
    },
    selsChange: function selsChange(sels) {
      this.sels = sels;
    },
    //租户
    getRenter: function getRenter() {
      var _this3 = this;
      this.listLoading = true;
      get(url.userManager.search + '?pageNum=0&pageSize=50').then(function (res) {
        _this3.renterList = res.data.datas;
        _this3.filters.companyId = res.data.datas[0].id;
        _this3.getUser();
      }).catch(function (error) {
        console.log(error);
      });
    },
    //用户概况数据
    getSituationData: function getSituationData() {
      var _this4 = this;
      this.listLoading = true;
      get(url.userManager.countAllUser).then(function (res) {
        console.log(res.data);
        _this4.firstPartData[0].number = res.data.tenantCount;
        _this4.firstPartData[1].number = res.data.userCount;
        _this4.firstPartData[2].number = res.data.normalCount;
        _this4.firstPartData[3].number = res.data.disabledCount;
      }).catch(function (error) {
        console.log(error);
      });
    },
    excleExport: function excleExport() {
      window.location.href = url.userManager.exportCompanyUser + '/' + this.filters.companyId + '?searchWord=' + this.filters.searchWord;
      /*  get(url.userManager.exportCompanyUser+'/'+this.filters.companyId,{searchWord:this.filters.searchWord}).then((res)=>{
              }).catch(error=>{
                console.log(error);
            });*/
    }
  }
};